import React from "react";
import { withAppState, getAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import {
  ButtonModalStyled,
  ThankYouPageStyled,
  ThankYouContainerStyled,
  IconStyled,
  HeadingStyled
} from "./styles/Styled";
import { withFocusable } from "../../services/visualLibraryService";
import { trackPage } from "../../services/analyticsService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";
import {getSubscriptionDisplayName} from "../../utils/promotionUtils"
import { getVoucherDurationText } from "../../services/copyService";

const PAGE = "thankYou";
const ButtonModalFocus = withFocusable(ButtonModalStyled);
const startWatchingFocusPath = "startWatchingVoucherModal_passThru";

class ThankYouPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      voucherData: props.applicationState.voucherData || getAppState().voucherData,
      voucherSubscriptionName: null,
    };
    this.onBack = this.onBack.bind(this);
    this.redirectToProfileSelection = this.redirectToProfileSelection.bind(this);
  }

  async componentDidMount() {
    const { voucherData } = this.state;
    trackPage(PAGE);
    this.props.onRef && this.props.onRef(this);
    this.setState({ voucherSubscriptionName: await getSubscriptionDisplayName(!!voucherData && voucherData.vouchers[0].subscriptions.join(",")) }); 
    getAppState().voucherData =  null;
  }

  componentWillUnmount() {
    getAppState().voucherData = null;
  }

  redirectToProfileSelection() {
    let path = routes.profileSelector;
      redirectTo.call(this, path, null, historyMethods.REPLACE);
  }

  onBack() {
    this.redirectToProfileSelection();
    return true;
  }

  render() {
    const {
      location: { state }
    } = this.props;
    const { voucherData } = this.state;

    const voucherDuration = !!voucherData && getVoucherDurationText(voucherData.vouchers[0].duration);
    
    return (
      <ThankYouPageStyled background="http://mena-img-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images/tizen/samsung-evoucher/samsungEvoucherThanksCover.jpg">
        <ThankYouContainerStyled>
          <IconStyled name="checkboxChecked" />
          {state && state.fromSignup && <HeadingStyled rank={1} text={i18n.get("pages.thankYou.welcome")} />}
          <HeadingStyled rank={1} text={i18n.get("pages.thankYou.HisenseGreetings", voucherDuration, this.state.voucherSubscriptionName && this.state.voucherSubscriptionName.toUpperCase())} />
          <ButtonModalFocus
            label={i18n.get("pages.thankYou.startWatching")}
            focusPath={startWatchingFocusPath}
            onEnterPress={this.redirectToProfileSelection}
            onMouseUp={this.redirectToProfileSelection}
            dataSnUp={""}
            dataSnDown={""}
            dataSnLeft={""}
            dataSnRight={""}
          />
        </ThankYouContainerStyled>
      </ThankYouPageStyled>
    );
  }
}

export default withAppState(ThankYouPage);
